import {
  AppNotificationDto,
  AppNotificationGroupDto,
} from '@act/shared/data-transfer-objects';
import { Box, Divider } from '@mui/material';
import { Fragment } from 'react';
import NotificationGroupContent from './notification-group-content';

interface NotificationCenterContentProps {
  notifications: AppNotificationDto[];
  notificationGroups: AppNotificationGroupDto[];
  onNotificationClick?: () => void;
}

const NotificationCenterContent = ({
  notifications,
  notificationGroups,
  onNotificationClick,
}: NotificationCenterContentProps) => {
  return (
    <Box sx={{ width: '100%' }}>
      {[...notificationGroups]
        .sort((a, b) => {
          if (b.sortOrder < a.sortOrder) return 1;
          if (b.sortOrder > a.sortOrder) return -1;
          return 0;
        })
        .map((group, index) => {
          return (
            <Fragment key={group.key}>
              <NotificationGroupContent
                group={group}
                notifications={notifications.filter(
                  n => n.notificationGroupType === group.key
                )}
                onNotificationClick={onNotificationClick}
              />
              {index !== notificationGroups.length - 1 && (
                <Divider sx={{ width: '100%' }} />
              )}
            </Fragment>
          );
        })}
    </Box>
  );
};

export default NotificationCenterContent;
